export default "__VITE_ASSET__e86df169__"